// extracted by mini-css-extract-plugin
module.exports = {"container":"MSelect_container__3cBPt","container--invalid":"MSelect_container--invalid__22UA0","select":"MSelect_select__1Lzjr","noSelect":"MSelect_noSelect__yptP4"};